import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Col, Table, Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import PropTypes from 'prop-types';
import { getProductDisplayName, getTypeDisplayName, AdvanceType } from '../../../../types/AdvanceTypeMapping';

import AdvanceStatusBadge from '../../Advances/AdvanceStatusBadge';
import { environment } from '../../../../environment/environment';
import AdvanceHistoryModal from '../../Advances/AdvanceHistoryModal';
import apiResponseHandler from '../../../../utils/apiResponseHandler';

const AdvanceRequests = ({ employeeId }) => {
  const [advanceRequests, setAdvanceRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAdvanceRequest, setSelectedAdvanceRequest] = useState();
  const [showAdvanceHistoryModal, setShowAdvanceHistoryModal] = useState(false);
  const [startDate, setStartDate] = useState(new Date(new Date().setMonth(new Date().getMonth() - 3)));
  const [endDate, setEndDate] = useState(new Date());
  const [advanceType, setAdvanceType] = useState("ALL");

  const onDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    getAdvanceRequests(advanceType, start, end);
  };

  const onTypeChange = (e) => {
    const type = e.target.value;
    setAdvanceType(type);
    getAdvanceRequests(type, startDate, endDate);
  };

  useEffect(() => {
    getAdvanceRequests(advanceType, startDate, endDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAdvanceRequests = (type, start, end) => {
    setLoading(true);

    const params = {
      employee: employeeId,
      start_date: start ? moment(start).format('YYYY-MM-DD') : undefined,
      end_date: end ? moment(end).add(1, 'days').format('YYYY-MM-DD') : undefined
    };

    if (type && type !== "ALL") {
      params.advance_type = type;
    }

    axios
      .get(`${environment.baseUrl}/advancerequests/`, { params })
      .then((res) => {
        setAdvanceRequests(res.data);
        setLoading(false);
      })
      .catch((err) => {
        apiResponseHandler.handleApiError('Error', err);
        setLoading(false);
      });
  };

  return loading ? (
    <Col className="d-flex justify-content-center mt-3">
      <output className="spinner-border">
        <span className="sr-only">Loading...</span>
      </output>
    </Col>
  ) : (
    <>
      <div className="d-flex my-3 px-3" style={{ gap: "20px" }}>
        <div style={{ width: "150px" }}>
          <Input
            type="select"
            name="advanceTypeFilter"
            id="advanceTypeFilter"
            bsSize="sm"
            value={advanceType}
            onChange={onTypeChange}
          >
            <option value="ALL">ALL</option>
            <option value={AdvanceType.EWA}>{AdvanceType.EWA}</option>
            <option value={AdvanceType.VAS}>{AdvanceType.VAS}</option>
          </Input>
        </div>
        <div style={{ width: "280px" }}>
          <DatePicker
            selected={startDate}
            onChange={onDateChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            className="form-control form-control-sm"
            placeholderText="Select date range"
          />
        </div>
      </div>

      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Type</th>
            <th scope="col">Amount</th>
            <th scope="col">Product</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {advanceRequests.map((advance) => (
            <tr key={advance.uuid}>
              <td>
                <div>{moment(advance.date_created).format('MMMM Do YYYY')}</div>
                <div>{moment(advance.date_created).format('h:mm:ss a')}</div>
              </td>
              <td style={{ textTransform: 'capitalize' }}>
                {getTypeDisplayName(advance.advance_type)}
              </td>
              <td>R {advance.amount_requested}</td>
              <td style={{ textTransform: 'capitalize' }}>
                {getProductDisplayName(advance.advance_type, advance.metadata, advance.instant_payment)}
                {advance.advance_type === 'VAS' &&
                  advance.metadata?.data?.transaction_type === 'data' &&
                  advance.metadata?.data?.data_package_selected && (
                    <div style={{ fontSize: '0.85rem', color: '#666' }}>
                      {advance.metadata.data.data_package_selected}
                    </div>
                  )}
              </td>
              <td>
                <AdvanceStatusBadge status={advance.status} />
              </td>
              <td>
                <button
                  className="btn bg-transparent btn-outline-primary"
                  style={{ display: 'flex', width: '6.25rem', padding: '0.375rem 0.75rem', alignItems: 'center', justifyContent: 'center', height: '1.3125rem', borderRadius: '0.4375rem', border: "1px solid", flexShrink: 0, color: "#062133CC" }}
                  onClick={() => {
                    setSelectedAdvanceRequest(advance);
                    setShowAdvanceHistoryModal(true);
                  }}>
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {showAdvanceHistoryModal && (
        <AdvanceHistoryModal
          advanceRequest={selectedAdvanceRequest}
          showAdvanceHistoryModal={showAdvanceHistoryModal}
          setShowAdvanceHistoryModal={setShowAdvanceHistoryModal}
        />
      )}
    </>
  );
};

AdvanceRequests.propTypes = {
  employeeId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
};

export default AdvanceRequests;
